import { useEffect, useState } from "react"
import { getOneTrustConsent } from "@/app/(site)/_utils/misc/getOneTrustConsent"

const useOneTrustOptInLoad = () => {
    const [scriptConsent, setScriptConsent] = useState(getOneTrustConsent())

    const updateConsent = () => {
        const newConsent = getOneTrustConsent()
        if (JSON.stringify(scriptConsent) !== JSON.stringify(newConsent)) {
            setScriptConsent(newConsent)
        }
    }

    useEffect(() => {
        window.addEventListener("OneTrustGroupsUpdated", updateConsent)
        window.addEventListener("OTConsentApplied", updateConsent)

        return () => {
            window.removeEventListener("OneTrustGroupsUpdated", updateConsent)
            window.removeEventListener("OTConsentApplied", updateConsent)
        }
    }, [])

    return scriptConsent
}

export default useOneTrustOptInLoad
